import React, { Component } from "react";

class Radio extends Component {
  constructor(props) {
    super(props);
  }

  handleClick = event => {
    this.props.handler(this.props.index);
  };

  handleHover = event => {
    this.props.hoverColor(event.currentTarget.dataset.val);
  };

  render() {
    return (
      <button
        type="button"
        className={
          (this.props.isChecked
            ? "checked btn-" + this.props.color
            : "unchecked btn-outline-" + this.props.color) + " btn"
        }
        onClick={this.handleClick}
        onMouseOver={this.handleHover}
        onMouseLeave={this.handleHover}
        data-val={this.props.text}
      >
        {this.props.text}
      </button>
    );
  }
}

export default Radio;
